import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { timezoneStringLabel } from '../../../dateUtils';
import timezones from './ReactTimezoneSelectTzList';
import './TimezoneSelector.scss';
var createTzOptionObject = function createTzOptionObject(tzStr) {
  if (!tzStr) {
    return null;
  }
  var label = timezoneStringLabel(tzStr);
  return {
    value: tzStr,
    label: label
  };
};
function TimezoneSelector(_ref) {
  var selectedValue = _ref.selectedValue,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var handleChange = function handleChange(timezone) {
    if (onChange) {
      onChange(timezone);
    }
  };
  var selectOptions = React.useMemo(function () {
    var americanTimeKeys = ['America/Los_Angeles', 'America/Denver', 'America/Chicago', 'America/New_York'];
    var otherTimezoneStrings = Object.keys(timezones).filter(function (timezone) {
      return !americanTimeKeys.includes(timezone);
    }).map(function (tzStr) {
      return createTzOptionObject(tzStr);
    }).sort(function (a, b) {
      var offsetA = parseFloat(a.label.slice(a.label.indexOf('(') + 4, a.label.indexOf(')')));
      var offsetB = parseFloat(b.label.slice(b.label.indexOf('(') + 4, b.label.indexOf(')')));
      return offsetA - offsetB;
    });
    var timezoneStrings = [].concat(_toConsumableArray(americanTimeKeys.map(function (tzStr) {
      return createTzOptionObject(tzStr);
    })), [createTzOptionObject('seperator')], _toConsumableArray(otherTimezoneStrings));
    return timezoneStrings;
  }, []);
  var formatOptionLabel = function formatOptionLabel(_ref2, _ref3) {
    var label = _ref2.label;
    var context = _ref3.context;
    if (context === 'menu') {
      if (label === 'seperator') {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("hr", {
          style: {
            margin: '8px 0'
          }
        }));
      }
    }
    return /*#__PURE__*/React.createElement("div", null, label);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "timezone-selector-component-container"
  }, /*#__PURE__*/React.createElement(Select, {
    value: createTzOptionObject(selectedValue),
    options: selectOptions,
    closeMenuOnSelect: true,
    classNamePrefix: "timezone-select",
    placeholder: "-Select one-",
    onChange: function onChange(newTimezone) {
      return handleChange(newTimezone.value);
    },
    isDisabled: disabled,
    formatOptionLabel: formatOptionLabel
  }));
}
TimezoneSelector.propTypes = {
  selectedValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
TimezoneSelector.defaultProps = {
  selectedValue: null,
  disabled: false
};
export default TimezoneSelector;